import {
    DestroyRef, Directive, HostListener, inject
} from "@angular/core";
import { ButtonDirective } from "./button.directive";
import { MatDialogRef } from "@angular/material/dialog";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ICheckChangesComponent } from "../../../forms/interfaces/check-changes-component";
import { FormUtil } from "../../../forms/form-util";
import { COMMON_APP_SERVICE } from "../../constants/app-tokens";
import { IAppService } from "../../interfaces/app-service";

/**
 * This button will close the dialog on click
 *
 * It should be attached to a MatDialog close button
 * If the dialog implements ICheckChangesComponent it will check for changes in the dialog,
 * if there are some prompt the user to confirm the closure
 * i.e.
 *s
 * <button mat-raised-button mgdDialogClose>Close</button>
 */
@Directive({
    selector: "[mgdDialogCloseButton]",
    hostDirectives: [
        {
            directive: ButtonDirective,
            inputs: ["stopClickEventPropagation", "mgdButtonType"]
        }
    ]
})
export class DialogCloseButtonDirective {

    private readonly _dialogRef = inject<MatDialogRef<ICheckChangesComponent>>(MatDialogRef, { optional: true });
    private readonly _app = inject<IAppService>(COMMON_APP_SERVICE);
    private readonly _destroyRef = inject(DestroyRef);

    /**
     * Check for changes in the dialog, if there are some prompt the user to confirm the closure
     */
    @HostListener("click")
    onClick(): void {

        if (this._dialogRef?.componentInstance) {
            FormUtil.handleFormLeave$(this._dialogRef.componentInstance, this._app.notificationService)
                .pipe(takeUntilDestroyed(this._destroyRef))
                .subscribe((close) => {
                    if (close) {
                        this._dialogRef.close();
                    }
                });
        }
    }
}
